import { apiFetch } from './api';
export const PUSH_HELP='On iPhone or iPad, add Pokeworks to your Home Screen, open it there, then enable notifications. On other devices, allow notifications in your browser’s site settings.';
export function supportsPush(){return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;}
async function registration(){
  if(!supportsPush())throw new Error(PUSH_HELP);
  let timer;
  try{return await Promise.race([navigator.serviceWorker.ready,new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('Notification setup timed out. Refresh and try again.')),8000);})]);}
  finally{clearTimeout(timer);}
}
export async function existingPush(){
  if (!supportsPush()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg?.pushManager ? reg.pushManager.getSubscription() : null;
}
export async function registerExistingPush(){
  const sub=await existingPush();
  if(!sub)return false;
  const data=await apiFetch('/api/push/subscribe',{method:'POST',body:JSON.stringify({subscription:sub})});
  if(!data.ok)throw new Error(data.message||'This device could not be registered.');
  return true;
}
export async function enablePush(){
  if(!supportsPush())throw new Error(PUSH_HELP);
  // Call permission directly from the user's click (required on iOS).
  if(Notification.permission!=='granted' && await Notification.requestPermission()!=='granted')throw new Error(PUSH_HELP);
  const reg=await registration();
  let sub=await reg.pushManager.getSubscription();
  if(!sub){
    const key=await apiFetch('/api/vapid-public-key');
    if(!key.ok||!key.publicKey)throw new Error('Notifications are not configured on the server.');
    const value=key.publicKey.replace(/-/g,'+').replace(/_/g,'/');
    const bytes=Uint8Array.from(atob(value+'='.repeat((4-value.length%4)%4)),c=>c.charCodeAt(0));
    sub=await reg.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:bytes});
  }
  const result=await apiFetch('/api/push/subscribe',{method:'POST',body:JSON.stringify({subscription:sub})});
  if(!result.ok)throw new Error(result.message||'This device could not be registered.');
  window.dispatchEvent(new Event('push-registration-changed'));
  return true;
}
export async function disconnectPush(){
  const sub=await existingPush();
  if(!sub)return;
  // Stop browser delivery immediately, even if server cleanup is unavailable.
  await sub.unsubscribe();
  window.dispatchEvent(new Event('push-registration-changed'));
  const result=await apiFetch('/api/push/subscribe',{method:'DELETE',timeoutMs:5000,body:JSON.stringify({endpoint:sub.endpoint})});
  if(!result.ok)throw new Error('Notifications stopped on this device. Server cleanup could not be confirmed.');
}
